<template>
  <div style="
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 30vh;
    ">
    <p class="page-container">抱歉，未找到该页面！</p>
    <el-button style="margin-top: 20px" @click="goBack" type="primary">返回</el-button>
  </div>
</template>
<script>

export default {
  name: 'sysAuthDict',
  created() {

  },
  components: {

  },
  watch: {},
  data() {
    return {

    }
  },
  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.page-container {
  font-size: 20px;
  text-align: center;
  color: rgb(192, 204, 218);
}
</style>
